export default __webpack_public_path__ + "static/media/evan-shapiro.bab9e5e3.jpeg";